.sync-modal--container {
  display: flex;

  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: 100%;

  height: 50vh;

  padding: 8px 32px;

  text-align: center;

  ion-icon {
    font-size: 48px;
  }
}

app-sync-modal ion-list {
  padding-top: 1rem;
}

ion-button.sync-done {
  --background: none;
  transition: background-position 2s linear;

  border-radius: 8px;

  background-image: linear-gradient(to right, var(--ion-color-primary) 50%, var(--ion-color-primary-tint) 50%);
  background-size: 200% 100%;

  font-weight: bold;

  &.complete {
    background-position: -100% 0%;
  }

  &.aborted {
    transition: background-position 1s linear;

    background-image: linear-gradient(to right, var(--ion-color-warning) 50%, var(--ion-color-warning-tint) 50%);
    background-position: -100% 0%;
  }
}

ion-footer.hidden {
  display: none;
}
